import { trackAction } from './ab_track';
import { initCompanyArchiveAreaSearchForm } from './company_archive_area_search_form';
import { initCompanyArchiveFitHeading } from './company_archive_fit_heading';
import { initCompanyArchiveAreaContext } from './company_area_context';
import { initBottomCvArea } from './ui/bottom_cv_area';
import { initSmoothAnchorLinks } from './ui/smooth_anchor_links';

const SIDEBAR_FORM_FIELD_NAMES = {
  'kind-reform[]': 'building_type',
  'client[prefecture_id]': 'prefecture',
  'client[budget_id]': 'budget',
};

function initCompanyArchiveTracking() {
  // documentへの委譲リスナーのため、再初期化時の多重登録を防ぐ
  if (document.documentElement.dataset.companyArchiveTrackingInitialized === 'true') return;
  document.documentElement.dataset.companyArchiveTrackingInitialized = 'true';

  // sendBeacon なので LP への遷移と競合せずに送信が完了する
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (!event.target.closest('#sidebar-fixed-form')) return;

    trackAction('sidebar_form_submitted');
  });

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    if (!select.closest('#sidebar-fixed-form')) return;
    if (select.value === '') return;

    trackAction('sidebar_form_field_selected', {
      field: SIDEBAR_FORM_FIELD_NAMES[select.name] || select.name,
      value: select.value,
      label: select.selectedOptions[0]?.textContent?.trim() ?? '',
    });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[data-track-company-archive-area-subsidy-link]');
    if (!(link instanceof HTMLAnchorElement)) return;

    trackAction('company_archive_area_subsidy_link_clicked', {
      path: window.location.pathname,
      destination_path: link.pathname,
    });
  });
}

function initCompanyArchiveFaq() {
  document.querySelectorAll('details[data-company-archive-faq-item] > summary').forEach((summary) => {
    const item = summary.parentElement;
    if (!(item instanceof HTMLDetailsElement)) return;

    summary.addEventListener('click', (event) => {
      if (item.open) event.preventDefault();
    });
  });
}

function initArchiveInteractions() {
  if (document.documentElement.dataset.companyArchiveInteractionsInitialized === 'true') {
    return;
  }

  document.documentElement.dataset.companyArchiveInteractionsInitialized = 'true';
  initBottomCvArea();
  initSmoothAnchorLinks();
  initCompanyArchiveAreaSearchForm();
  initCompanyArchiveAreaContext();
  document.addEventListener('htmx:afterSwap', (event) => {
    initCompanyArchiveAreaSearchForm(event.target);
  });
  initCompanyArchiveFaq();
  initCompanyArchiveFitHeading();
  initCompanyArchiveTracking();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArchiveInteractions);
} else {
  initArchiveInteractions();
}
